import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LMNavigationService } from './lm-navigation.service';

@Component({
  selector: 'lm-navigation',
  template: `<div>Redirecting...</div>`,
})
export class LMNavigationComponent implements AfterViewInit {

  constructor(
    private router: Router,
    private lmNavigationService: LMNavigationService
  ) {}

  ngAfterViewInit() {
    this.redirect(this.router.url);
  }

  redirect(navigationUrl: string) {
    const delimiter = navigationUrl.indexOf('?') ===  -1 ? '?' : '&';
    navigationUrl += delimiter + 'output=spec';
    this.lmNavigationService.runNavigation(navigationUrl, undefined, { replaceUrl: true });
  }

  checkSaveRequired() {
    return false;
  }

  public allowPageNavigation(): Promise<boolean> | boolean {
    return true;
  }
}
